<template>
  <div class="cmi-alert-view">
    <div v-if="aniAlertLoading" class="cmi-loading-feedback">
      <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span>
      <span>Loading alert message</span>
    </div>
    <div v-if="showAlert" class="alert alert-warning" role="alert">
      <button
        @click="closeAlert"
        type="button"
        class="close"
        aria-label="Close"
      >
        <span class="fa fa-times"></span>
      </button>
      <button
        @click="toggleMarguee"
        type="button"
        class="close"
        aria-label="Close"
        style="margin-right:10px;"
      >
        <span class="fa fa-pause"></span>
      </button>
      <marquee-text :paused="pauseText">
        <p>
          {{ fdata.message }}
        </p>
      </marquee-text>
    </div>
  </div>
</template>
<script>
import MarqueeText from "vue-marquee-text-component";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  components: {
    MarqueeText
  },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        message: ""
      },
      showAlert: false,
      pauseText: false,
      aniAlertLoading: false
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    getAlertDetails: async function() {
      this.aniAlertLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      let rData = null;
      let actionUrl = `${this.baseUrl}GetAlertDetails`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniAlertLoading = false;
        throw error;
      }

      if (rData != 0) {
        Object.assign(this.fdata, rData);
        if (this.fdata.message) {
          this.showAlert = true;
        }
      }
      this.aniAlertLoading = false;
    },
    closeAlert: function() {
      this.showAlert = false;
    },
    toggleMarguee: function() {
      this.pauseText = !this.pauseText;
    }
  },
  async mounted() {
    await this.getAlertDetails();
  }
};
</script>
